import React from "react";

import {makeStyles, withStyles} from "@material-ui/core/styles";

import Warning from "@material-ui/icons/Warning";
import Icon from "@material-ui/core/Icon";
import FlagIcon from '@material-ui/icons/Flag';
import LocalOffer from "@material-ui/icons/LocalOffer";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import DateRange from "@material-ui/icons/DateRange";
import Divider from '@material-ui/core/Divider';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';


import Card from "../../components2/Card/Card";
import CardHeader from "../../components2/Card/CardHeader";
import CardIcon from "../../components2/Card/CardIcon";
import CardFooter from "../../components2/Card/CardFooter";

import Danger from "components/Typography/Danger.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import {getAccountSeries} from "../../utils/request";
import {MineViewStudyTime} from "../components/mine_view_study_time";
import Success from "../../components/Typography/Success";
import CardBody from "../../components2/Card/CardBody";
import intl from "react-intl-universal";


class AccountSchedule extends React.Component {


	constructor(props, context) {
		super(props, context);
		this.state = {
			userAllActiveCourse: '-',
			userAllStudyCourse: '-',
			userAllStudyTime: '',
			userAllLastActive: '0',

			userWeekStudyCourse: '0',
			userWeekStudyTime: '',
			userWeekStudyCourseChange: '0',
			userWeekStudyTimeChange: '+0,0',

			userMonthStudyCourse: '0',
			userMonthStudyTime: '',
			userMonthStudyCourseChange: '0',
			userMonthStudyTimeChange: '-0,0',

			weekCourseColor: '#4caf50',
			weekTimeColor: '#DE587B',
			monthCourseColor: '#4caf50',
			monthTimeColor: '#DE587B',

			userAllLastActiveText: '',


			seriesInfo: [],
			showModel: false
		}
		this.initData();
	}

	initData = () => {
		getAccountSeries().then(res => {
			// alert(res.code)
			this.setState({
					userAllStudyCourse: res.data.userAllStudyCourse,
					userAllActiveCourse: res.data.userAllActiveCourse,
					userAllStudyTime: res.data.userAllStudyTime,
					userAllLastActive: res.data.userAllLastActive,

					userWeekStudyCourse: res.data.userWeekStudyCourse,
					userWeekStudyCourseChange: res.data.userWeekStudyCourseChange,
					userMonthStudyCourse: res.data.userMonthStudyCourse,
					userMonthStudyCourseChange: res.data.userMonthStudyCourseChange,

					userWeekStudyTime: res.data.userWeekStudyTime,
					userMonthStudyTime: res.data.userMonthStudyTime,
					userWeekStudyTimeChange: res.data.userWeekStudyTimeChange,
					userMonthStudyTimeChange: res.data.userMonthStudyTimeChange,

					seriesInfo: res.data.userSeries,
				}
				, () => {
					this.changeWMTipColor()
				}
			)
		});
	};

	getCurrentDay = (time) => {
		const currentTime = new Date().getTime();

		const diffTimeHour = (currentTime - parseInt(time)) / 1000 / 60 / 60;
		if (diffTimeHour <= 1) {
			return intl.get('just');
		} else if (diffTimeHour <= 24) {
			return intl.get('today');
		} else if (diffTimeHour <= 24 * 7) {
			return intl.get('weekly');
		} else if (diffTimeHour <= 24 * 31) {
			return intl.get('month');
		} else if (diffTimeHour <= 24 * 31 * 6) {
			return intl.get('in_half_year');
		} else {
			return intl.get('out_half_year');
		}
	};

	changeWMTipColor = () => {
		this.setState({
			weekCourseColor: parseInt(this.state.userWeekStudyCourseChange) >= 0 ? '#4caf50' : '#DE587B',
			weekTimeColor: parseInt(this.state.userWeekStudyTimeChange) >= 0 ? '#4caf50' : '#DE587B',
			monthTimeColor: parseInt(this.state.userMonthStudyTimeChange) >= 0 ? '#4caf50' : '#DE587B',
			monthCourseColor: parseInt(this.state.userMonthStudyCourseChange) >= 0 ? '#4caf50' : '#DE587B',
			userAllLastActiveText: this.getCurrentDay(this.state.userAllLastActive)
		});


		if (parseInt(this.state.userWeekStudyTimeChange.split(",")[0]) > 100) {
			this.setState({
				userWeekStudyTimeChange: '+100h +'
			})
		} else if (parseInt(this.state.userWeekStudyTimeChange.split(",")[0]) < -100) {
			this.setState({
				userWeekStudyTimeChange: '-100h +'
			})
		} else {
			this.setState({
				userWeekStudyTimeChange: this.state.userWeekStudyTimeChange.split(",")[0] + 'h' + this.state.userWeekStudyTimeChange.split(",")[1] + 'm',

			})
		}

		if (parseInt(this.state.userMonthStudyTimeChange.split(",")[0]) > 100
		) {
			this.setState({
				userMonthStudyTimeChange: '+100h +'
			})

		} else if (parseInt(this.state.userMonthStudyTimeChange.split(",")[0]) < -100
		) {
			this.setState({
				userMonthStudyTimeChange: '-100h +'
			})
		} else {
			this.setState({
				userMonthStudyTimeChange: this.state.userMonthStudyTimeChange.split(",")[0] + 'h' + this.state.userMonthStudyTimeChange.split(",")[1] + 'm',
			})
		}
		;

	};

	render() {
		const {classes} = this.props;
		return (
			<div>
				<div className={classes.title}>
					<h2>{intl.get('my_schedule')}: </h2>
				</div>
				<div className={classes.title}>
					<h4>{intl.get('learning_overview')}: </h4>
				</div>
				<GridContainer>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="danger" stats icon>
								<CardIcon color="danger">
									<FlagIcon/>
								</CardIcon>
								<p className={classes.cardCategory}></p>
								<h3 className={classes.cardTitle}>
									{this.state.userAllActiveCourse}
								</h3>
							</CardHeader>
							<CardFooter stats>
								<div className={classes.stats}>
									<LocalOffer/>
									{intl.get('course_not_taken')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="success" stats icon>
								<CardIcon color="success">
									<ThumbUpIcon/>
								</CardIcon>
								<p className={classes.cardCategory}></p>
								<h3 className={classes.cardTitle}>
									{this.state.userAllStudyCourse}
								</h3>
							</CardHeader>
							<CardFooter stats>
								<div className={classes.stats}>
									<LocalOffer/>
									{intl.get('complete_the_course')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
				</GridContainer>
				<GridContainer>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="warning" stats icon>
								<CardIcon color="warning">
									<QueryBuilderIcon/>
								</CardIcon>
								<p className={classes.cardCategory}></p>
								<h3 className={classes.cardTitle}>
									<MineViewStudyTime data={this.state.userAllStudyTime}/>
								</h3>
							</CardHeader>
							<CardFooter stats>
								<div className={classes.stats}>
									<DateRange/>
									{intl.get('study_time')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="info" stats icon>
								<CardIcon color="info">
									<QueryBuilderIcon/>
								</CardIcon>
								<p className={classes.cardCategory}></p>
								<h3 className={classes.cardTitle}>
									{this.state.userAllLastActiveText}
								</h3>
							</CardHeader>
							<CardFooter stats>
								<div className={classes.stats}>
									<DateRange/>
									{intl.get('last_study_time')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
				</GridContainer>
				<Divider variant="middle"/>
				<div className={classes.title}>
					<h4>近期目标: </h4>
				</div>

				<GridContainer>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="primary" stats icon>
								<CardIcon color="primary">
									<FlagIcon/>
								</CardIcon>
								<p className={classes.cardCategory}>{intl.get('7_day')}</p>
								<h3 className={classes.cardTitle}>
									{this.state.userWeekStudyCourse}
								</h3>

							</CardHeader>
							<CardBody style={{
								margin: '0px',
								padding: '10px'
							}}>
								<div style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									color: `${this.state.weekCourseColor}`,
									fontSize: '16pt'
								}}>
									{this.state.userWeekStudyCourseChange}
									{this.state.userWeekStudyCourseChange.substring(0, 1) === '+'
										?
										<ArrowUpward style={{margin: '0px'}}/>
										:
										<ArrowDownwardIcon style={{margin: '0px'}}/>
									}
								</div>
							</CardBody>
							<CardFooter stats>
								<div className={classes.stats}>
									<LocalOffer/>
									{intl.get('complete_the_course')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="primary" stats icon>
								<CardIcon color="primary">
									<QueryBuilderIcon/>
								</CardIcon>
								<p className={classes.cardCategory}>{intl.get('7_day')}</p>
								<h3 className={classes.cardTitle}>
									<MineViewStudyTime
										data={this.state.userWeekStudyTime}
									/>
								</h3>

							</CardHeader>
							<CardBody style={{
								margin: '0px',
								padding: '10px'
							}}>
								<div style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									color: `${this.state.weekTimeColor}`,
									fontSize: '16pt'
								}}>
									{this.state.userWeekStudyTimeChange}
									{this.state.userWeekStudyTimeChange.substring(0, 1) === '+'
										?
										<ArrowUpward style={{margin: '0px'}}/>
										:
										<ArrowDownwardIcon style={{margin: '0px'}}/>
									}
								</div>
							</CardBody>
							<CardFooter stats>
								<div className={classes.stats}>
									<DateRange/>
									{intl.get('study_time')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
				</GridContainer>
				<GridContainer>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="rose" stats icon>
								<CardIcon color="rose">
									<FlagIcon/>
								</CardIcon>
								<p className={classes.cardCategory}>{intl.get('30_day')}</p>
								<h3 className={classes.cardTitle}>
									{this.state.userMonthStudyCourse}
								</h3>

							</CardHeader>
							<CardBody style={{
								margin: '0px',
								padding: '10px'
							}}>
								<div style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									color: `${this.state.monthCourseColor}`,
									fontSize: '16pt'
								}}>
									{this.state.userMonthStudyCourseChange}
									{this.state.userMonthStudyCourseChange.substring(0, 1) === '+'
										?
										<ArrowUpward style={{margin: '0px'}}/>
										:
										<ArrowDownwardIcon style={{margin: '0px'}}/>
									}
								</div>
							</CardBody>
							<CardFooter stats>
								<div className={classes.stats}>
									<LocalOffer/>
									{intl.get('complete_the_course')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
					<GridItem xs={12} sm={6} md={4}>
						<Card>
							<CardHeader color="rose" stats icon>
								<CardIcon color="rose">
									<QueryBuilderIcon/>
								</CardIcon>
								<p className={classes.cardCategory}>{intl.get('30_day')}</p>
								<h3 className={classes.cardTitle}>
									<MineViewStudyTime
										data={this.state.userMonthStudyTime}
									/>
								</h3>

							</CardHeader>
							<CardBody style={{
								margin: '0px',
								padding: '10px'
							}}>
								<div style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									color: `${this.state.monthTimeColor}`,
									fontSize: '16pt'
								}}>
									{this.state.userMonthStudyTimeChange}
									{this.state.userMonthStudyTimeChange.substring(0, 1) === '+'
										?
										<ArrowUpward style={{margin: '0px'}}/>
										:
										<ArrowDownwardIcon style={{margin: '0px'}}/>
									}
								</div>
							</CardBody>
							<CardFooter stats>
								<div className={classes.stats}>
									<DateRange/>
									{intl.get('study_time')}
								</div>
							</CardFooter>
						</Card>
					</GridItem>
				</GridContainer>
			</div>


		);
	}
}

export default withStyles(styles)(AccountSchedule)